export const truncateWithEllipsis = (text: string, limit?: number): string => {
  const characterLimit = limit ?? 15;
  return text.length <= characterLimit
    ? text
    : `${text.substring(0, characterLimit)}...`;
};
